import { render } from "./IndexDropdown.vue?vue&type=template&id=6e675d26"
import script from "./IndexDropdown.vue?vue&type=script&lang=js"
export * from "./IndexDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script